import React from 'react'
import styled from 'styled-components'
import PastPageItem from './PastPageItem'
import Heading from '../../atoms/Heading'

const Container = styled.aside`
  max-width: 100%;
  background: ${({ theme }) => theme.palette.background.lightBrown};
  @media (min-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    top: 3972px;
  }
`

const PastPageTitle = styled.div`
  width: 176px;
  height: 16px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  color: ${({ theme }) => theme.palette.font.main};
  margin-right: 18px;
  @media (max-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    display: none;
  }
`

const PastPageItemContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  justify-content: center;
  padding: 64px;
  @media (max-width: ${({ theme }) => theme.mediaQuery.desktop.minWidth}) {
    padding: 32px;
  }
`

export default function PastPage() {
  const links: { year: string; slug: string }[] = [
    { year: '2022', slug: '2022_spring' },
    { year: '2021', slug: '2021_spring' },
    { year: '2020秋', slug: '2020_autumn' },
    { year: '2020春', slug: '2020_spring' },
    { year: '2019秋', slug: '2019_autumn' },
    { year: '2019春', slug: '2019_spring' },
    { year: '2018秋', slug: '2018_half' },
  ]
  return (
    <Container>
      <Heading>過去のママリ口コミ大賞</Heading>
      <PastPageItemContainer>
        <PastPageTitle>過去のママリ口コミ大賞</PastPageTitle>
        {links.map((value, index) => {
          return (
            <PastPageItem key={index} text={value.year} to={`https://award.mamari.jp/${value.slug}/`}></PastPageItem>
          )
        })}
      </PastPageItemContainer>
    </Container>
  )
}
